import Vue from 'vue';
const EventBus = new Vue();

export default EventBus;

export const SHOW_TOAST_MESSAGE = 'show-toast-message';
export const HIDE_TOOLTIP_EVENT = 'hide-tooltip';
export const ACTIVATE_ALL_EVENT = 'activate-all';
